import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { ConversionRateIcon, TotalCampaignsIcon, TotalClicksIcon } from '../../icons';
import StatCardSkeleton from '../../containers/user-container/StatCardSkeleton';
const StatCards = ({ stats = [], loading = false, selectedStatus = '', onStatClick }) => {
     const [initialLoading, setInitialLoading] = useState(true);
    useEffect(() => {
   if (!loading) {
      setInitialLoading(false);
   }
}, [loading]);
    const iconMap = [
        <TotalCampaignsIcon />,
        <TotalClicksIcon />,
        <ConversionRateIcon />,
    ];
    const StatCardsData = stats.map((item, index) => ({
        ...item,
        icon: iconMap[index] || <TotalCampaignsIcon />,
    }));
    return (
        <>
            {
                initialLoading ? (
                    <div className="gap-16 updatedData">
                        {[...Array(3)].map((_, i) => (
                            <StatCardSkeleton key={i} />
                        ))}
                    </div>
                ) : (
                    <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px' }}>
                        {StatCardsData.map((item, index) => {
                            const isActive = selectedStatus === item.filterKey;
                            return (
                                <Box
                                    key={index}
                                    onClick={() => onStatClick?.(item.filterKey)}
                                    sx={{
                                        cursor: "pointer",
                                        padding: "14px 20px",
                                        borderRadius: "8px",
                                        border: isActive ? '1px solid #ff4A4A' : '1px solid #E8E8E8',
                                        background: "#fff",
                                        transition: "0.3s",
                                        display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px',
                                        marginTop: '20px',
                                        boxShadow: isActive ? '0 0 0 2px rgba(145, 96, 8, 0.12)' : 'none',
                                        '&:hover': {
                                            borderColor: '#ff4A4A',
                                        },
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                                        <Box sx={{'& svg path':{stroke: isActive ? '#ff4a4a' : '#000'}}}>
                                            {item.icon}
                                        </Box>
                                    </Box>

                                    <Typography sx={{ color: isActive ? '#ff4A4A' : '#3C4043', fontSize: '14px', textTransform: 'uppercase', fontWeight: '500', fontFamily: "Neue Montreal", marginBottom: '8px' }}>
                                        {item.subTitle}
                                    </Typography>

                                    <Typography sx={{ fontSize: "18px", fontWeight: 500, fontFamily: "Neue Montreal", color: isActive ? '#ff4A4A' : '#000' }}>
                                        {item.title}
                                    </Typography>

                                </Box>
                            );
                        })}
                    </Box>
                )
            }


        </>

    )
}

export default StatCards
